/**
 * Tag Component
 */

import { getBackgroundSizeClassName } from '../../styles/background-size';
import { getColorSchemeClassName } from '../../styles/color-schemes';
import { getBackgroundColorClassName, getTextColorClassName } from '../../styles/colors';
import './styles.scss';

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

import Button from '../../atoms/buttons/Button';
import LinkButton, { LinkButtonProps } from '../../atoms/buttons/LinkButton';
import Badge from '../../atoms/feedback/Badge';
import { IconArrowRight, IconExclude, IconX } from '../../atoms/images/Icon';
import Label, { LabelProps } from '../../atoms/text/Label';

interface IOwnProps extends ITextColorProps, IBackgroundColorProps, IBackgroundSizeProps {
  alwaysDisplayExclude?: boolean;
  cardinality?: number;
  colorScheme?: 'light' | 'transparent' | 'dark' | 'white';
  className?: string;
  disabled?: boolean;
  exclude?: boolean;
  hasSubtags?: boolean;
  id: string;
  taxonomy: GQL.ITaxonomy;
  label: string;
  linkProps?: LinkButtonProps;
  prefix?: string;
  removeOnClick?: boolean;
  size?: TagSize;
  style?: React.CSSProperties;
  subtags?: Tag[];
  variant?: TagVariant;
  wrappedComponent?: 'div' | 'li';
  onClick?(tagId: string): any;
  onClickExclude?(tagId: string): any;
  onClickSubTags?(tagId: string): any;
  onRemove?(id: string): any;
}

export type TagProps = IOwnProps;

const classes = new BEM('tag');

export default class Tag extends React.Component<IOwnProps, {}> {
  static defaultProps: Partial<IOwnProps> = {
    colorScheme: 'light',
    size: 'medium',
    variant: 'simple',
    wrappedComponent: 'div',
  };

  onClick = () => {
    const {
      id,
      onClick,
      onRemove,
      removeOnClick,
    } = this.props;

    if (removeOnClick && onRemove) {
      onRemove(id);
    }

    if (onClick) {
      onClick(id);
    }
  }

  render() {
    const {
      alwaysDisplayExclude,
      backgroundColor,
      backgroundSize,
      cardinality,
      className,
      colorScheme,
      disabled,
      exclude,
      hasSubtags,
      id,
      label,
      linkProps,
      onClick,
      onClickExclude,
      onClickSubTags,
      onRemove,
      prefix,
      size,
      textColor,
      variant,
    } = this.props;

    const WrappedComponent: any = this.props.wrappedComponent!;
    const Wrapper: any = variant === 'filter' ? 'div' : linkProps ? LinkButton : 'div';

    let wrapperProps = {};

    if (Wrapper === 'button') {
      wrapperProps = {
        type: 'button',
        onClick: this.onClick,
        disabled,
      };
    } else if (Wrapper === LinkButton) {
      wrapperProps = linkProps!;
    } else if (!!onClick && !disabled) {
      wrapperProps = {
        onClick: this.onClick,
      };
    }

    const classesModifiers = {
      [variant!]: variant !== 'simple',
      'disabled': !!disabled,
      'exclude': !!exclude,
      'no-link': variant === 'simple' && !onClick && Wrapper !== LinkButton,
      [size!]: true,
    };

    const extraClasses = classNames(
      getTextColorClassName(textColor),
      getBackgroundColorClassName(backgroundColor),
      getBackgroundSizeClassName(backgroundSize),
      getColorSchemeClassName(colorScheme),
      className,
    );

    const labelProps: LabelProps = {
      ...classes('label'),
      WrappedComponent: 'span',
    };

    return (
      <WrappedComponent {...classes('', classesModifiers, extraClasses) }>
        {variant === 'button' &&
          <Button
            {...classes('button', 'exclude', classNames(alwaysDisplayExclude && 'visible')) }
            size="xsmall"
            variant="icon-no-padding"
            icon={<IconExclude />}
            onClick={() => {
              if (onClickExclude) {
                onClickExclude(id);
              }
            }}
          />
        }
        <Wrapper {...classes('wrapper') } {...wrapperProps}>
          {prefix &&
            <Label {...labelProps}><strong>{prefix}:</strong>&nbsp;</Label>
          }
          {exclude &&
            <Label {...labelProps}>Not&nbsp;</Label>
          }
          <Label {...labelProps} text={label} />
          {cardinality && <Badge label={String(cardinality)} {...classes('badge') } />}
        </Wrapper>
        {variant === 'filter' &&
          <Button
            {...classes('button', 'remove') }
            onClick={() => onRemove && onRemove(id)}
            variant="icon-no-padding"
            icon={<IconX />}
          />
        }
        {hasSubtags && (
          <Button
            {...classes('button', 'subtags') }
            onClick={() => onClickSubTags && onClickSubTags(id)}
            variant="icon"
            icon={<IconArrowRight />}
          />
        )}
      </WrappedComponent>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/Tag/index.tsx